import { render, staticRenderFns } from "./TimeslotFeatures.vue?vue&type=template&id=5f5b0058&scoped=true"
import script from "./TimeslotFeatures.vue?vue&type=script&lang=js"
export * from "./TimeslotFeatures.vue?vue&type=script&lang=js"
import style0 from "./TimeslotFeatures.vue?vue&type=style&index=0&id=5f5b0058&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f5b0058",
  null
  
)

export default component.exports